import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Input from "components/ProjectNonSpecificComponents/Elements/Input"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router"
import styled from "styled-components"
import AppRequests from "../API/AppRequests/AppRequests"
import ROUTES from "../Constants/ROUTES"
import { useStore } from "../Contexts/GlobalStoreContext"
import MediumButton from "../Elements/Global/atoms/Buttons/MediumButton"

const AdminLoginPage = observer(() => {
	const [password, setPassword] = useState<string>("")

	const history = useHistory()
	const { t } = useTranslation()
	const store = useStore()

	useEffect(() => {
		if (store.userHasAdminAccess) {
			store.setLoaderOverlayOpen(true)
			history.push(ROUTES.CONNECT)
		}
	}, [])

	const logIn = async (e: { preventDefault: () => void }) => {
		e.preventDefault();
		const { ok, data, statusCode } = await AppRequests("Admin").post<any>("access", { psword: window.btoa(password)})
		if (ok && data == true) {
			store.setLoaderOverlayOpen(true)
			sessionStorage.setItem("access", "true")
			store.setUserHasAdminAccess(true)
			history.push(ROUTES.CONNECT)
		} else if (statusCode == 423) {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "admin.fail"
			})
		}
	}

	return (
		<AdminLoginOverlay onSubmit={logIn}>
			<HyperDiv width="100%" height="100%" centered>
				<HyperDiv width="400px" style={{ maxWidth: "95vw" }} alignedLeft direction="column">
					<p>{t("admin.enterPassword")}</p>
					<Whitespace x="0.3" />
					<Input
						onChange={(e) => setPassword(e.target.value)}
						value={password}
						wide
						type="password"
					/>
					<Whitespace x="1" />
					<MediumButton type="submit">{t("admin.log-in")}</MediumButton>
				</HyperDiv>
			</HyperDiv>
		</AdminLoginOverlay>
	)
})

export default AdminLoginPage

const AdminLoginOverlay = styled.form`
	width: 100vw;
	height: 100vh;
	position: absolute;
	top: 0px;
	left: 0px;
	overflow-y: hidden;
	overflow-y: hidden;
	background-color: white;
	background: #fff; // Backup
`
